import {
    GET_BLEMISH_REPORT_REQUEST,
    GET_BLEMISH_REPORT_SUCCESS,
    GET_BLEMISH_REPORT_FAILURE,
    GET_BLEMISH_FIELD_SUCCESS,
} from '../constants/questions_constants/get_blemish_report.constants';

import { UPDATE_BLEMISH_REPORT_REQUEST, UPDATE_BLEMISH_REPORT_FAILURE, UPDATE_BLEMISH_REPORT_SUCCESS } from '../constants/questions_constants/update_blemish_report.constants';

const initialState = {
    loading: false,
    blemish_report: null,
    blemish_report_loading: false,
    error: null,
};

export const Lead_blemish_report = (state = initialState, action) => {
    switch (action.type) {
    case 'SET_BLEMISH_REPORT':
        return {
            ...state,
            ...action.payload,
        };
    case GET_BLEMISH_REPORT_REQUEST:
        return {
            ...state,
            blemish_report_loading: true,
        };
    case GET_BLEMISH_REPORT_SUCCESS:
        return {
            ...state,
            blemish_report: action.questions,
            blemish_report_loading: false,

        };
    case GET_BLEMISH_FIELD_SUCCESS:
        return {
            ...state,
            blemish_report: { ...state.blemish_report, [action.field]: action.payload },
            blemish_report_loading: false,
        };
    case GET_BLEMISH_REPORT_FAILURE:
        return {
            ...state,
            error: action.error,
            blemish_report_loading: false,
        };

    case UPDATE_BLEMISH_REPORT_REQUEST:
        return {
            ...state,
            blemish_report_loading: true,
        };

    case UPDATE_BLEMISH_REPORT_SUCCESS:
        return {
            ...state,
            blemish_report: action.payload,
            blemish_report_loading: false,

        };
    case UPDATE_BLEMISH_REPORT_FAILURE:
        return {
            ...state,
            error: action.error,
            blemish_report_loading: false,
        };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/lead_blemish_report.reducer.js